import React from 'react';
import video from '../../assets/images/video-based.svg';
import transport from '../../assets/images/transport.svg';
import productivity from '../../assets/images/productivity.svg';
import arrowblack from '../../assets/images/arrow-black.svg';


const OneSolution = () => {
  return (  
    <div className="one-solution fs-15">
      <div className="row">
        <div className="col-lg-7">
          <div className="one-solution-img">
          </div>
          <div className="text">
            <h2 className="text-primary fs-36 font-weight-normal one-solution-heading">One Solution for many <br></br>problems</h2>
            <p className="mt-3 text-gray fs-14">The all-round program dramatically improves the overall<br></br> performance of the fleet</p>
            <div className="media">
              <img src={arrowblack} alt="Black Arrow" className="mr-2 mt-2"/>
              <div className="media-body">
                <p className="font-weight-bold fs-14">Play Video</p>
              </div>
            </div>
          </div>
        </div>        
        <div className="col-lg-5 fs-14 centered">
          <div className="media icons pl-5">
            <img src={video} alt="Video" className="mr-4" />
            <div className="media-body">
              <p className="font-weight-bold text-black">Video-based<br></br> safety program</p>
              <p className="text-gray font-weight-semibold">Lowers collision frequency, fuel consumption,<br></br> and operational costs</p>
            </div>
          </div>
          <div className="media icons pl-5">
            <img src={transport} alt="Transport" className="mr-4" />
            <div className="media-body">
              <p className="font-weight-bold text-secondary">Transport Intelligence</p>
              <p className="text-black font-weight-semibold">Improve driver efficiency and vehicle use with<br></br> real-time data collection</p>
            </div>
          </div>
          <div className="media icons pl-5">
            <img src={productivity} alt="Productivity" className="mr-4" />
            <div className="media-body">
              <p className="font-weight-bold text-black">Productivity and <br></br>compliance</p>
              <p className="text-gray font-weight-semibold">Customised solutions to lower<br></br> ownership costs</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
 
export default OneSolution;